import { Button } from '@/components/ui/button';
import { useAuth } from '@/components/auth/AuthProvider';
import TenantDCCSubmissions from './TenantDCCSubmissions';
import { LogOut } from 'lucide-react';
import TenantInlineLogin from '@/components/auth/TenantInlineLogin';

export default function TenantDCCAdmin() {
  const { signOut, user } = useAuth();

  // If not authenticated, show inline login here (no separate /access page for DCC)
  if (!user) {
    return (
      <div className="min-h-screen bg-white">
        <div className="max-w-7xl mx-auto p-4 sm:p-6">
          <TenantInlineLogin />
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white">
      {/* Top bar */}
      <div className="sticky top-0 z-40 flex h-14 items-center justify-between border-b border-gray-200 bg-white px-4">
        <div className="font-semibold text-gray-800">Tenant Dashboard - Dubai CommerCity</div>
        <Button variant="ghost" size="sm" onClick={signOut}>
          <LogOut className="h-4 w-4 mr-1" /> Sign out
        </Button>
      </div>

      {/* Content */}
      <div className="max-w-7xl mx-auto p-4 sm:p-6">
        <TenantDCCSubmissions />
      </div>
    </div>
  );
}

